interface DatadogProxyRequest {
  path: string
  parameters: string
  subdomain?: string
}

// Maps SDK intake requests onto the static rewrites in next.config.js. The
// SDK calls this for every intake request (RUM batches, logs, profile
// uploads, and the profiling quota check); the rewrite then forwards to the
// matching intake origin. Only the quota subdomain exists today; anything
// unrecognized falls back to the main intake origin, matching the SDK's
// fail-open quota behavior.
//
// The `{ path, parameters, subdomain }` contract is Datadog's documented
// proxy-function form:
// https://docs.datadoghq.com/real_user_monitoring/guide/proxy-rum-data/
export function buildDatadogProxyUrl({
  path,
  parameters,
  subdomain,
}: DatadogProxyRequest): string {
  const prefix =
    subdomain === 'quota' ? '/api/datadog/quota' : '/api/datadog/main'
  // The leading `e=1` breaks the `<path>?ddsource=` adjacency that
  // EasyPrivacy's host-independent rules (`/rum?ddsource=`, `/logs?ddsource=`,
  // `/replay?ddsource=`) anchor on — without it they block our same-origin
  // proxy despite the rewrite. Intake reads parameters by name and ignores
  // unknown ones. See the regression test and discoveries.md.
  const query = parameters ? `?e=1&${parameters}` : ''
  return `${prefix}${path}${query}`
}
